import { createAssetManagementClient } from '@/shared/api/client'
import { validateResponse, validateResponseIsOk } from '@/shared/api/validation'
import { z } from 'zod'
import { createManualInvoiceSchema } from '../schemas'

const client = createAssetManagementClient()

export const createWheelingInvoice = (invoiceDetails: z.infer<typeof createManualInvoiceSchema>) =>
    validateResponseIsOk(client.sendPost(`assets/${invoiceDetails.assetCode}/billing/invoices`, { data: createManualInvoiceSchema.parse(invoiceDetails)}))
.then((data) => {
})